import { render, staticRenderFns } from "./dic_process_list.vue?vue&type=template&id=a0b0c5cc&scoped=true"
import script from "./dic_process_list.vue?vue&type=script&lang=js"
export * from "./dic_process_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b0c5cc",
  null
  
)

export default component.exports